/* eslint-disable no-unused-vars */
import React, { useContext, useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import { connect } from "react-redux";
import Modal from "modules/common/components/Modal";
import withForm from 'modules/common/hoc/withForm';
import { ModalContext } from "App";
import { omitEmptyArgs } from "helper";
import PropTypes from "prop-types";
import Alert from "react-s-alert";
import * as actions from "../action";
import * as c from "../constant";

function AdditionalCostsModal({
  createData,
  type,
  dataInfo,
  updateData,
  getList,
  showData,
  createInputNumber,
  formData,
  setFormData,
  history,
  createInput,
}) {
  const setModal = useContext(ModalContext);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (type === 'NEW') {
      createData(omitEmptyArgs(formData), (data) => {
        setModal({ isOpen: false });
        getList();
        history.push(
          `/rpt/building/settings/additional-costs/${data.data.id}`
        );
        showData(data.data.id);
      });
    }

    if (type === 'EDIT') {
      updateData(dataInfo.id, omitEmptyArgs(formData), (data) => {
        setModal({ isOpen: false });
        getList();
        history.push(
          `/rpt/building/settings/additional-costs/${data.data.id}`
        );
        showData(data.data.id);
      });
    }

  };

  const handleOnClose = (e) => {
    if (e) e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    if (type === "EDIT") {
      setFormData({
        ...formData,
        name: _.get(dataInfo, 'attributes.name'),
        description: _.get(dataInfo, 'attributes.description'),
        cost: _.get(dataInfo, 'attributes.cost'),
      });
    }
  }, []);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className='row'>
          <div className='col-12 form-group'>
            {createInput(
              { key: 'name', label: 'Name:' },
              { required: true }
            )}
          </div>
          <div className='col-12 form-group'>
            {createInput(
              { key: 'description', label: 'Description:' },
              { required: true }
            )}
          </div>
          <div className='col-12 form-group'>
            {createInputNumber(
              { key: 'cost', label: 'Cost:' },
              { required: true }
            )}
          </div>
        </div>
        <div className='d-flex justify-content-center mt-4'>
          <button type='submit' className='btn btn-md btn-primary cms-bg-color-primary cms-outline-primary  mr-1 cms-bg-color-primary'>
            Submit
          </button>
          <button
            type='button'
            onClick={handleOnClose}
            className='btn btn-light ml-1'
          >
            Cancel
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

AdditionalCostsModal.defaultProps = {
  type: '',
  dataInfo: {},
};

AdditionalCostsModal.propTypes = {
  createData: PropTypes.instanceOf(Function).isRequired,
  updateData: PropTypes.instanceOf(Function).isRequired,
  type: PropTypes.string,
  dataInfo: PropTypes.instanceOf(Object),
  getList: PropTypes.instanceOf(Function).isRequired,
  showData: PropTypes.instanceOf(Function).isRequired,
  createInputNumber: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  createInput: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = () => ({
});

const enhance = _.flowRight([
  withRouter,
  withForm,
  connect(mapStateToProps, actions),
]);

export default enhance(AdditionalCostsModal);
